<template>
    <div>
        <div v-if="getTaskPreparedEdit>-1">{{prepareEdit(getTaskPreparedEdit)}}</div>
        <div v-if="getAxiosRefresh == 3">{{initData()}}</div>

        <v-layout row wrap v-if="myContent">
        <v-expansion-panels v-model="panels" multiple flat class="px-6">
        <v-expansion-panel>
            <v-expansion-panel-header><b>Content</b></v-expansion-panel-header>
            <v-expansion-panel-content>
            <!-- show -->
            <v-layout row wrap>
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if = "getShowTaskIndex >-1" 
                    :class="['card-border-style position-relative overflow-hidden read-only--background read-only--border-color', 
                                (getTaskVertic == true) ? 'rounded-tl-lg rounded-tr-lg':'rounded-tl-lg rounded-bl-lg']">

                    <div v-if="myContent.languages[getShowTaskIndex].permissions && !myContent.islocked" class="universal-row-item__group-btn-panel read-only--border-color">
                            <div class="lang-side">
                                <img class="lang-side__img" :src="getLanguageIcons[getShowTaskIndex].url" />
                            </div>
                            <v-icon @click="prepareEdit(getShowTaskIndex)" dense>edit</v-icon>
                            <v-icon @click ="clearTranslation(getShowTaskIndex)" dense>delete</v-icon>                                
                            <v-icon v-if="myContent.languages[getShowTaskIndex].visible == 0" @click="changeVisibility(getShowTaskIndex)" dense>visibility_off</v-icon>                                       
                            <v-icon v-else @click="changeVisibility(getShowTaskIndex)" dense>visibility</v-icon>  
                            <v-icon class="border-l read-only--border-color" @click="$store.commit('setShowTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                    </div>
                    <div v-html="myContent.languages[getShowTaskIndex].content" class="pa-2"></div>
                </v-flex>

            <!-- edit -->
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" 
                    :class="['card-border-style position-relative overflow-hidden', 
                                (getShowTaskIndex > -1 && getTaskVertic == false) ? 'border-l-none rounded-tr-lg rounded-br-lg':'', 
                                (getShowTaskIndex > -1 && getTaskVertic == true) ? 'border-t-none rounded-br-lg rounded-bl-lg':'', 
                                (getShowTaskIndex > -1) ? '':'rounded-lg']">

                    <div class="universal-row-item__group-btn-panel">
                            <div class="lang-side">
                                <img class="lang-side__img" :src="getLanguageIcons[getEditTaskIndex].url" />
                            </div>

                            <v-icon v-if="getShowTaskIndex > -1"  title="copy all content" @click="copyContent()" dense>content_copy</v-icon>
                            <v-icon v-if="getShowTaskIndex > -1"  title="translate all content" @click="translateContent()" dense>add_road</v-icon>
                            <v-icon title="show html" v-if="!showedHTML" @click="showHTML()" dense>code</v-icon>
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" dense>save</v-icon>
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" dense>check_circle</v-icon>
                            <v-icon title="close without save" @click="closeTask()" dense>meeting_room</v-icon>
                            
                            <v-icon class="border-l" @click="$store.commit('setEditTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                    </div>

                    <v-card-text>
                        <v-layout row wrap class="pa-2">
                            <v-flex xs12>
                                <quill-editor v-model='tmpContent' :options="getEditorOption()" />
                            </v-flex>
                        </v-layout>
                    </v-card-text>             
                </v-flex>
            </v-layout>
        </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>              
        </v-layout>

        <v-layout v-if="myContent && getEditTaskIndex > -1" class="d-flex align-end flex-column border-t mt-5 pa-2">
            <div class="btn-group-a">
                <img class="btn-group-a__divider-item" :src="getLanguageIcons[getEditTaskIndex].url" width="20" />
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--green" dense>save</v-icon>
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--blue" dense>check_circle</v-icon>
            </div>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
// import { codemirror } from 'vue-codemirror'
// import 'codemirror/lib/codemirror.css'
import * as es from '../../../../assets/editor_settings.js'
import axios from '../../../../axios-auth'
import {translateHtmlWithExclusions } from "../../../../assets/translat.js";


export default {
    data() {
        return {
                showedHTML : false,
                myContent: null,
                tmpContent: '',
                panels: [0]
              }
    },
    props: {
        my_element: Object, 
        objectChangePermission : Boolean
    },
    computed: 
            mapGetters([
                        'getLanguageIcons',
                        'getCountdownStatus',
                        'getShowTaskIndex',
                        'getEditTaskIndex',
                        'getTaskVertic',
                        'getTaskPreparedEdit',
                        'getAxiosRefresh'
                        ])
    ,
    components: {
        quillEditor
    },
    mounted() {
        if (this.getAxiosRefresh !=3 ) this.initData()
    },
    methods: {
        // ************ main methods
        getEditorOption() { return es.getEditorOption() },
        getCmOptions() { return es.getCmOptions('text/html', false) },   
        changeVisibility(_index) {
            this.$store.commit('setTaskNewVisibility', 1 - this.myContent.languages[_index].visible)
            this.$store.commit('setTaskChangeVisibility', true)
            this.myContent.languages[_index].visible = 1 - this.myContent.languages[_index].visible                   
        },
        prepareEdit(_index) {  
            this.$store.commit('setTaskPreparedEdit',-1)  
            if (!this.myContent.languages[_index].permissions || this.myContent.islocked) return
            this.$store.commit('setEditTaskIndex', _index)
            this.tmpContent = this.myContent.languages[_index].content
        },
        closeTask() { this.$router.go(-1) },

        // ******** end of main methods
        // *********************************

        initData() {
            // this.$store.commit('setFeedback', null)
            this.$store.commit('setAxiosRefresh',-1)
            this.myContent = this.my_element            
            // edit permission for language?
            if (this.getEditTaskIndex > -1 && (!this.myContent.languages[this.getEditTaskIndex].permissions || this.myContent.islocked)) {
                this.$store.commit('setEditTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
            }            
            if (this.getShowTaskIndex == this.getEditTaskIndex) {
                this.$store.commit('setShowTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
                this.prepareEdit(this.getEditTaskIndex)
            }             
        },
        copyContent() {
            if (this.getShowTaskIndex > -1)
              this.tmpContent = this.myContent.languages[this.getShowTaskIndex].content
        },
        async translateContent() {
            // 1) rýchly exit ak nie je čo zobraziť / prekladať
            if (this.getShowTaskIndex < 0) return;

            try {
                const res = await axios.post(
                    "/gettapi",
                    null, // žiadne telo; null je čistejšie ako {}
                    this.$store.getters.getAxiosConfig
                );

                // 3) skontroluj odpoveď a prítomnosť tokenu
                if (res.data.message !== "OK" || !res.data.apikey) {
                    this.$store.commit("setFeedback", "Nepodarilo sa získať API token.");
                    return;
                }

                // 4) bezpečne načítaj HTML
                const html = this.myContent.languages[this.getShowTaskIndex].content || "";
                if (!html.trim()) {
                    this.$store.commit("setFeedback", "Nie je žiadny HTML obsah na preklad.");
                    return;
                }

                // 5) zavolaj preklad so správnym názvom parametra (accessToken)
                this.tmpContent = await translateHtmlWithExclusions({
                    html,
                    sourceLang: this.getLanguageIcons[this.getShowTaskIndex].title.toLowerCase(),
                    targetLang: this.getLanguageIcons[this.getEditTaskIndex].title.toLowerCase(),
                    accessToken: res.data.apikey, 
                    // excludeTags: [...], // voliteľne
                });
            } catch (error) {
                // 6) jednotná error vetva
                this.$store.commit("setFeedback", error);
            }                     
        },
        clearTranslation(_index) { 
            if (!this.myContent.languages[_index].translated) return
            this.tmpContent = ''
            this.saveData(false,_index, 1)
            this.$store.commit('setShowTaskIndex', -1)
        },
        saveData(_close, _index, _only_translation) { 
          if (this.myContent.id == 0 && (this.myContent.course_id === undefined || this.myContent.lesson_id === undefined)) {
              this.$store.commit('setFeedback', 'Data about course and/or lesson is missing')
              return
          }
          const _data = {
            task_id: this.myContent.id,
            course_id: this.myContent.course_id, // will be checked on backend
            lesson_id: this.myContent.lesson_id,
            task_type: 'C',
            task_type_id: this.myContent.task_type_id,
            max_score: this.myContent.max_score,
            // task_order: this.myContent.task_order,
            content: this.tmpContent, // new data
            globals: '',
            lang_id: _index + 1,
            only_translation: _only_translation 
          }

        axios.post('/edit-task', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
            } 

            if (this.myContent.id == 0 || this.myContent.task_type_id != this.$route.params.id_type) { // new - refresh  
                if (this.myContent.id == 0)  // new - refresh                  
                    this.myContent.id = res.data.task_id

                this.$store.commit('setShowTaskIndex', _index)
                this.$store.commit('setEditTaskIndex', _index)

                this.$router.replace({name:'task_edit', params: {
                    id: this.myContent.id,
                    id_type: this.myContent.task_type_id, 
                    show_lang: _index, 
                    edit_lang: _index, 
                    course_id: this.myContent.course_id, 
                    lesson_id: this.myContent.lesson_id
                }})
            }
            
            if (_close) this.closeTask()   
            this.$store.commit('setAxiosRefresh', 1)
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
        }, 
    }
}
</script>

<style>

</style>

